<template>
  <div class="task-detail-card" :class="position">
    <div class="task-detail-header">
      <img :src="task.iconUrl" alt="Task Icon" class="task-icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TaskDetailCard",
  props: {
    task: {
      type: Object,
      required: true
    },
    position: {
      type: String,
      default: 'right',
      validator: (value) => ['left', 'right'].includes(value)
    }
  }
}
</script>

<style scoped>
.task-detail-card {
  position: absolute;
  top: 0;
  width: 300px;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  opacity: 0;
  transition: opacity 0.3s ease, transform 0.3s ease;
  z-index: 9999 !important;
  pointer-events: none;
  visibility: hidden;
}

.task-detail-card.right {
  right: -320px;
  transform: translateX(20px);
}

.task-detail-card.left {
  left: -320px;
  transform: translateX(-20px);
}

.task-item:hover .task-detail-card {
  opacity: 1;
  transform: translateX(0);
  pointer-events: all;
  visibility: visible;
}

.task-detail-header {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #F6F8FA;
  border-radius: 12px;
  height: fit-content;
  width: 100%;
}

.task-icon {
  object-fit: contain;
  padding: 10px;
  width: auto;
  max-height: 452px;
}

.task-detail-body {
  padding: 20px;
}

.task-name {
  font-size: 18px;
  font-weight: 600;
  color: #101828;
  margin-bottom: 10px;
}

.task-detail-desc {
  font-size: 14px;
  color: #667085;
  margin-bottom: 20px;
  line-height: 1.5;
}

.task-detail-footer {
  display: flex;
  justify-content: center;
}

.xp-large {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #FCF5E8;
  border-radius: 20px;
  padding: 8px 16px;
  font-weight: 600;
  font-size: 16px;
}

.xp-icon-large {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

/* Mobil cihazlar için responsive davranış */
@media (max-width: 768px) {
  .task-detail-card {
    position: fixed;
    top: 50%;
    left: 50%;
    right: auto;
    transform: translate(-50%, -50%) scale(0.9);
    width: 90%;
    max-width: 300px;
    opacity: 0;
    z-index: 1000;
  }

  .task-item:hover .task-detail-card {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
}
</style>
